import { render, staticRenderFns } from "./salesBigDeliveryPlace.vue?vue&type=template&id=799c1c3b&scoped=true"
import script from "./salesBigDeliveryPlace.vue?vue&type=script&lang=js"
export * from "./salesBigDeliveryPlace.vue?vue&type=script&lang=js"
import style0 from "./salesBigDeliveryPlace.vue?vue&type=style&index=0&id=799c1c3b&prod&scoped=true&lang=css"
import style1 from "./salesBigDeliveryPlace.vue?vue&type=style&index=1&id=799c1c3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c1c3b",
  null
  
)

export default component.exports